import { TermoConsentimento } from "./TermoConsentimento";

export default TermoConsentimento;